import GalleryGrid from '../components/GalleryGrid'
import CTASection from '../components/CTASection'
import SectionHeader from '../components/SectionHeader'
import { GALLERY } from '../content/siteContent'

export default function GalleryPage() {
  return (
    <main>
      {/* Page hero */}
      <section className="bg-gradient-to-br from-brand-navy to-brand-blue pt-32 pb-16 relative overflow-hidden">
        <div className="absolute inset-0 opacity-[0.04]" style={{ backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)', backgroundSize: '32px 32px' }} aria-hidden="true" />
        <div className="section-container relative z-10 text-center">
          <p className="text-brand-amber text-xs font-round font-bold tracking-[0.15em] uppercase mb-3">Photos</p>
          <h1 className="text-4xl md:text-5xl font-display font-bold text-white mb-4">{GALLERY.headline}</h1>
          <p className="text-slate-200 text-lg max-w-xl mx-auto">{GALLERY.subheadline}</p>
        </div>
        <div className="absolute bottom-0 left-0 right-0" aria-hidden="true">
          <svg viewBox="0 0 1440 60" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full" preserveAspectRatio="none">
            <path d="M0 60V30C240 0 480 50 720 30C960 10 1200 50 1440 30V60H0Z" fill="white" />
          </svg>
        </div>
      </section>

      {/* Gallery grid */}
      <section className="section-pad bg-white">
        <div className="section-container">
          <SectionHeader eyebrow={`${GALLERY.images.length} Photos`} headline="Our Community in Pictures" subheadline="Click any photo to view it larger. Every image tells a story of learning, joy, and belonging." />
          <GalleryGrid />
        </div>
      </section>

      <CTASection
        headline="Want to See It in Person?"
        subheadline="Photos are great, but nothing beats walking through our doors and meeting our team. Schedule a personal tour today."
      />
    </main>
  )
}
